import http from "../../../request";

export default {
  collections: async (context) => {
    let response = await http.get(`collections`, localStorage.getItem("lang"));
    context.commit("setCollection", response);
  },
  collectionDetails: async (context, payload) => {
    let response = await http.get(
      `collections/${payload}`,
      localStorage.getItem("lang")
    );
    context.commit("setCollectionDetails", response);
  },
  resetCollectionDetails: (context) => {
    context.commit("resetCollectionDetails");
  },
};
